import { Component, ContentChild, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { NgScrollbar } from 'ngx-scrollbar';
import { NgClass, NgStyle, NgTemplateOutlet } from '@angular/common';
import { SELECTED_OPTION } from '../../overlays/option-list.constants';
import { IChecklist } from '../checklist-input/checklist-input.component';
import { IItemTrackingChecklist } from '@app/store/item-tracking/item-tracking.reducer';
import { OPTIONS } from '@app/framework/constants/options-list.constants';

export type ChecklistOption = {
  action: SELECTED_OPTION;
  checklist?: IChecklist | IItemTrackingChecklist;
  index?: number;
};

@Component({
  selector: 'app-checklist-dropdown',
  templateUrl: './checklist-dropdown.component.html',
  styleUrls: ['./checklist-dropdown.component.scss'],
  imports: [NgScrollbar, NgTemplateOutlet, NgStyle, NgClass],
})
export class ChecklistDropdownComponent {
  @Input() listItems: string[] = [];
  @Input() disabledActionList: OPTIONS[] = [];
  @Output() selectedOption = new EventEmitter();

  @ContentChild(TemplateRef) projectedContentTemplate: TemplateRef<any>;
  @Input() checkLists: IChecklist[] | IItemTrackingChecklist[] = [];
  @Input() selectedId: number = null;
  @Input() showNoChecklistOption = true;
  @Input() width: any;
  SELECTED_OPTION = SELECTED_OPTION;

  optionSelected(item: ChecklistOption) {
    this.selectedOption.emit(item);
  }
}
